/**
 * Results
 *
 * View that interactions on the results list
 *
 * @return {View}
 */

OT.createNS('OT.Redesign.Views.Results.Results');

OT.Redesign.Views.Results.Results = Backbone.ViewManager.BaseView.extend({
    el: '#search_results',

    events: {},

    initialize: function () {
        var self = this;

        // Listen for result updates
        OT.Events.on('results:updated', function () { self.render(); });

        // Set information about filters
        this.currentSort = OT.Search.Data.get().Request.SortString;

        // Initialise lazy loading of restaurant images
        setTimeout(OT.Common.LazyLoadImages.init);

        new OT.Redesign.Views.SearchTabs();
        (new OT.Redesign.Views.Filters.Sort()).reInitializeSortDropdown();
    },


    beforeRender: function () {
        if (OT.Search.Helpers.isMapShowing()) {
            this.unsetView();
            return false;
        }

        this.template = 'Redesign/Results/_ResultsTable';
        this.templateData = OT.Search.Data.get();
        this.$el.show();

        // If it's not an availability request, then we want to bug out here
        if (!OT.Search.Data.get().Request.IsAvailabilityRequest) {
            return true;
        }

        // If it is an availability request, then we want to render the correct
        // view based on the results total
        if (OT.Search.Data.get().Results.Total === 0) {
            this.template = 'Redesign/Results/_NoResults';
            this.additionalData = {
                clearLastFilter: OT.Search.History.count() > 1
            };
        }

        return this;
    },

    onRender: function() {
        setTimeout(function() {
            OT.Common.LazyLoadImages.init();
            new OT.Redesign.Views.SearchTabs();
            (new OT.Redesign.Views.Filters.Sort()).reInitializeSortDropdown();
        });
        OT.Search.recentlyBooked();
        OT.Search.stylesheet();
        if (OT.SV359) {
            OT.SV359.recentlyViewed();
        }
        if (OT.SV955) {
            OT.SV955.addSimilar();
        }

        OT.Events.fire('results:rendered');

        if (OT.SV1371) {
            OT.SV1371.slideTimeslots('left');
            OT.SV1371.slideTimeslots('right');
        }
    }
});
